import { Badge } from '@cloudflare/kumo'
import { useTranslation } from '../i18n'

/**
 * Epson Connect reachability, independent of the lifecycle `PrinterStatus`
 * badge — an `active` printer can be offline. `connected` is the last probe
 * (`null` = never checked); `checkedAt` goes in the tooltip.
 */
interface Props {
  connected: boolean | null
  checkedAt: string | null
}

export function PrinterConnectionBadge({ connected, checkedAt }: Props) {
  const { t } = useTranslation()
  const key = connected === null ? 'unknown' : connected ? 'online' : 'offline'
  const label = t(`printers.connection.${key}`)
  const variant = connected === null ? 'neutral' : connected ? 'success' : 'error'
  const title = checkedAt
    ? t('printers.connection.checkedAt', { date: new Date(checkedAt).toLocaleString() })
    : undefined
  return (
    // Kumo's Badge takes no `title`; the span carries the tooltip.
    <span title={title}>
      <Badge variant={variant} aria-label={label}>
        {label}
      </Badge>
    </span>
  )
}
